import React from "react";
import SystemReportingIcon from "../../assets/icons/reporting_system.svg2";
import Subheading from "../Common/Subheading";

export default function SystemReportingPage() {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <Subheading
          Icon={SystemReportingIcon}
          heading="System Wide Information "
          subheading="Look at how your account is being utilised"
        />
      </div>
      <div className="my-3 rounded-3"></div>
    </div>
  );
}
